import config from '../../../config';
import Rakuten from './TrackingAffiliate/Rakuten';
import CookieGenerator from './TrackingAffiliate/CookieGenerator';
import Awin from './TrackingAffiliate/Awin';
import CommissionFactory from './TrackingAffiliate/CommissionFactory';
import Facebook from './TrackingAffiliate/Facebook';
import OptimiseMedia from './TrackingAffiliate/OptimiseMedia';

const awin = new Awin();
const rakuten = new Rakuten();
const commissionFactory = new CommissionFactory();
const facebook = new Facebook();
const optimiseMedia = new OptimiseMedia();

let cookieGenerator = new CookieGenerator(awin, rakuten, commissionFactory, facebook, optimiseMedia);

export const urlParamsChecker  = (urlParams) => {
  let { utm_source = '', awc, ranMID, ranSiteID, cfclick, fbclid, sskey } = urlParams;
  utm_source = utm_source.toLowerCase();

  if (
    (!utm_source || utm_source === 'commissionfactory') &&
    commissionFactory.isStoreSupported(config.storeCode) &&
    cfclick
  ) {
    // further info available in the migrated ticket clickup #3rt08hy accessible by product tech
    commissionFactory.setUrlParams({ cfclick });
    cookieGenerator.addForAffiliate('commission-factory');
  } else if (
    utm_source === 'awin' && 
    awc && 
    awin.isStoreSupported(config.storeCode)
  ) {
    awin.setUrlParams({ awc });
    cookieGenerator.addForAffiliate('awin');
  } else if (
    utm_source === 'optimise' && 
    sskey && 
    optimiseMedia.isStoreSupported(config.storeCode)
  ) {
    optimiseMedia.setUrlParams({ sskey });
    cookieGenerator.addForAffiliate('optimise-media');
  } else if (
    utm_source === 'rakuten' &&
    ranMID &&
    ranSiteID
  ) {
    rakuten.setUrlParams({ utm_source, ranMID, ranSiteID });
    cookieGenerator.addForAffiliate('rakuten');
  } else if (
    utm_source === 'facebookads' &&
    fbclid
  ) {
    facebook.setUrlParams({ fbclid });
    cookieGenerator.addForAffiliate('facebookads');
  }
};

export const cleanAfterConfirm = () => {
  cookieGenerator.clearAffiliates();
};



// WEBPACK FOOTER //
// ./src/Common/Helpers/SetCookiesHelper.js